import { render, staticRenderFns } from "./Checks.vue?vue&type=template&id=484a52c3&scoped=true"
import script from "./Checks.vue?vue&type=script&lang=js"
export * from "./Checks.vue?vue&type=script&lang=js"
import style0 from "./Checks.vue?vue&type=style&index=0&id=484a52c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a52c3",
  null
  
)

export default component.exports